package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class FollowUserDto(
    val userId: String,
    val username: String,
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val overallRating: Double = 0.0,
    val position: String? = null,
    val club: String? = null,
    val city: String? = null,
    val country: String? = null,
    val cardImageUrl: String? = null,
    val cardAvatarUrl: String? = null,
    val followedAt: String
)

@Serializable
data class FollowUserPageDto(
    val items: List<FollowUserDto>,
    val page: Int,
    val size: Int,
    val totalItems: Long,
    val totalPages: Int,
)

@Serializable
data class FollowCountsDto(
    val followersCount: Long,
    val followingCount: Long
)

@Serializable
data class FollowRelationDto(
    val isFollowing: Boolean,
    val isFollowedBy: Boolean,
    val isMutual: Boolean
)
